import QRCode from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import { Bank } from 'hooks/webapi/client/useBanksQuery';
import { composeQRPayment } from 'utils/bankAccountFormat';
import { Button } from '..';
import CopyValue from '../CopyValue/CopyValue';
import s from './PaymentDetails.module.scss';

function PaymentDetails({ value }: { value: Bank }) {
  const { t } = useTranslation('identification_manual');
  const DEFAULT_FEE = 0.01;

  const qrPayment = (bankDetails: Bank) => {
    return composeQRPayment({
      countryCode: 'CZ',
      bankAccount: bankDetails.accountNumber,
      variableSymbol: bankDetails.clientIdentificationNumber,
      amount: DEFAULT_FEE,
      currency: 'CZK',
    });
  };

  const downloadQR = () => {
    const canvas = document.getElementById('qrCodeEl') as HTMLCanvasElement;
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = `Bank details.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className={s.box}>
      <div className={s['bank-row']}>
        <div className={s['bank-row-content']}>
          <div className={s['qr-code']}>
            <QRCode size={105} value={qrPayment(value)} id="qrCodeEl" />
            <Button
              onClick={downloadQR}
              outline
              wide
              size="s"
              className={s['qr-mobile-download']}
            >
              {t('download')}
            </Button>
          </div>
          <div className={s['qr-notice']}>
            {t('qrcode_notice')}
            <span>{t('qrcode_tooltip')}</span>
          </div>
        </div>
        <div className={s['bank-separator']}>
          <span className={s['bank-separator-badge']}>
            {t('bank_separator')}
          </span>
        </div>
      </div>
      <CopyValue
        label={t('payee')}
        value={value.receiver}
        copyLabel={t('copy')}
        confirmLabel={t('copied')}
      />
      <div className={s['details-separator']} />
      <CopyValue
        label={t('bank_name')}
        value={value.bankName}
        copyLabel={t('copy')}
        confirmLabel={t('copied')}
      />
      <div className={s['details-separator']} />
      <CopyValue
        label={t('account_number')}
        value={value.accountNumber}
        copyLabel={t('copy')}
        confirmLabel={t('copied')}
      />
      <div className={s['details-separator']} />
      <CopyValue
        label={t('variable_symbol')}
        value={value.clientIdentificationNumber}
        copyLabel={t('copy')}
        confirmLabel={t('copied')}
      />
    </div>
  );
}

export default PaymentDetails;
